import React from "react";
import LogInForm from "./components/LogInForm";

import urlImageMFV from "../../assets/img/logo.png";
import backgroundImage from "../../assets/img/img_login1.jpeg";

const LogIn = () => (
  <div className="account">
    <div className="account__wrapper">
      <div className="account__card">
        <img
          src={urlImageMFV}
          style={{ objectFit: "contain", height: "200px", marginBottom: "3%" }}
        />
        <div className="account__head">
          <h3 className="account__title">
            Bienvenido a
            <span className="account__logo">
              {" "}
              Contratación
              <span className="account__logo-accent"></span>
            </span>
          </h3>
        </div>
        <LogInForm onSubmit />
      </div>
    </div>
    <div className="login-image-section">
      <img src={backgroundImage} alt="Background" className="bg-full-height" />
    </div>
  </div>
);

export default LogIn;

// if you want to add select, date-picker and time-picker in your app you need to uncomment the first
// four lines in /scss/components/form.scss to add styles
